import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { useAsync } from 'react-use'

import { Form as AntdForm, Row, Col, Card, Button, Input, Skeleton } from 'antd'
import { SaveOutlined, CloseOutlined } from '@ant-design/icons'

import { useAuth } from '../../../contexts/AuthContextProvider'
import { isAllowed } from '../../../route/roles'

const Form = () => {
  const navigate = useNavigate()
  const { firebaseApp, db, role } = useAuth()
  const { bid } = useParams()
  const [loading, setLoading] = useState(false)

  const readOnly = !isAllowed(role, 'edit', 'masters', 'branches')

  const { value } = useAsync(async () => {
    if (!bid) {
      return {}
    }

    const snap = await db.collection('/branches').doc(bid).get()
    return {
      ...snap.data(),
      id: snap.id
    }
  }, [bid])

  const handleSubmit = async (formData) => {
    try {
      setLoading(true)
      if (!bid) {
        const snap = await db.collection('/branches').orderBy('createddate', 'desc').limit(1).get()
        const branches = snap.docs.map(doc => doc.id)
        const branchId = (branches.length) ? parseInt(branches[0]) + 1 : 1
        await db.collection('/branches').doc(`${branchId}`).set({
          ...formData,
          createddate: firebaseApp.firestore.FieldValue.serverTimestamp()
        })
      } else {
        await db.collection('/branches').doc(bid).set(formData, {
          merge: true
        })
      }
      setLoading(false)
      navigate('/admin/masters/branches')
      return Promise.resolve()
    } catch (error) {
      setLoading(false)
      return Promise.reject(error)
    }
  }

  if (!value) return <Skeleton></Skeleton>
  return (
    <Card style={{ padding: 48, minHeight: '100%' }}>
      <div style={{ marginBottom: 16, fontSize: 24 }}>
        {(!bid) ? 'สร้าง' : ''}สาขา
      </div>
      <AntdForm
        layout='vertical'
        onFinish={handleSubmit}
        initialValues={value}
      >
        <Row gutter={[24, 32]}>
          <Col span={8}>
            <AntdForm.Item name='name' label='ชื่อสาขา' rules={[{ required: true, message: 'กรุณาใส่ชื่อสาขาด้วยค่ะ' }]}>
              <Input placeholder='ชื่อสาขา' disabled={readOnly} />
            </AntdForm.Item>
          </Col>
          <Col span={8}></Col>
          <Col span={8}></Col>
        </Row>
        <div>
          {(!readOnly) && (
            <Button
              loading={loading}
              style={{ width: 168, height: 40, marginTop: 20, marginRight: 20 }}
              htmlType='submit'
              type='primary'
            ><SaveOutlined style={{ fontSize: 16 }} />บันทึก</Button>
          )}
          <Button
            loading={loading}
            style={{ height: 40, marginTop: 20 }}
            onClick={() => {
              navigate(-1)
            }}
          ><CloseOutlined />ปิด</Button>
        </div>
      </AntdForm>
    </Card>
  )
}

export default Form
